module.exports = require("oncoprintjs");